import { useMemo } from 'react';
import { ePartyPurpose } from '../../../../../../ui-toolkit/enums/ePartyPurpose';
import { IParty } from '../../../../../../ui-toolkit/orders/interfaces/IParty';

export const useGetBorrowerBuyerSeller = (
  parties: IParty[]
): { borrowers: IParty[]; buyers: IParty[]; sellers: IParty[] } => {
  return useMemo(() => {
    const borrowers = parties.filter((p) => p.purpose === ePartyPurpose.borrower);
    const buyers = parties.filter((p) => p.purpose === ePartyPurpose.buyer);
    const sellers = parties.filter((p) => p.purpose === ePartyPurpose.seller);
    return { borrowers, buyers, sellers };
  }, [parties]);
};
